/**
 * Wire protocol.
 *
 * WebSocket *text* frames carry JSON control messages (join, upgrades, match
 * lifecycle, leaderboards). WebSocket *binary* frames carry the hot path:
 * input frames up, world snapshots down. See `codec.ts` for the binary layout.
 */
export const BINARY_INPUT = 0x01;
export const BINARY_SNAPSHOT = 0x81;
/** Movement key bits inside an input frame. */
export const MOVE_UP = 1 << 0;
export const MOVE_DOWN = 1 << 1;
export const MOVE_LEFT = 1 << 2;
export const MOVE_RIGHT = 1 << 3;
/** Action bits inside an input frame. */
export const ACT_FIRE = 1 << 0;
export const ACT_AUTOFIRE = 1 << 1;
export const ACT_AUTOSPIN = 1 << 2;
//# sourceMappingURL=protocol.js.map